/*
 * Epycure · prix testés par Shoplift sur la page produit.
 *
 * Shoplift remplace, une seule fois, le texte des éléments marqués data-sl-attribute-p / -cap.
 * Or le thème calcule beaucoup de prix à partir du prix d'une variante (prix abonné, prix par
 * jour, « Économisez X € », pourcentages), et son JS réécrit les prix à chaque changement de
 * variante à partir des data-base-price / data-discounted-price des boutons radio.
 *
 * Ce script :
 * 1. relit le prix testé de chaque variante dans les sondes du snippet epycure-shoplift-sondes,
 *    où Shoplift l'écrit (valable en ligne comme dans l'aperçu Shoplift, et dans les deux sens :
 *    Shoplift peut afficher un prix plus bas que celui de Shopify) ;
 * 2. réécrit les data-attributs des boutons radio, pour que le JS du thème affiche ensuite le
 *    prix testé à chaque clic ;
 * 3. recalcule les éléments marqués data-epy-prix (voir plus bas) ;
 * 4. ajoute properties._slpt aux ajouts au panier : le JS du thème construit sa requête sans les
 *    propriétés du formulaire, et sans _slpt le panier facturerait le prix d'origine ;
 * 5. remplace, pour un abonnement, le plan Recharge par celui de la version affichée (voir
 *    planPourVersion).
 *
 * Tant qu'aucune sonde ne change (pas de test, ou visiteur sur la version d'origine), il ne
 * touche à rien.
 *
 * Éléments recalculés : data-epy-prix = prix | barre | economie | pourcent | jour
 *   data-epy-v       identifiant de variante, « actif » (le bouton radio coché du produit
 *                    data-epy-produit) ou « groupe » (la variante affichée par le groupe
 *                    « Achat unique » qui contient l'élément)
 *   data-epy-remise  remise de l'abonnement en %, pour un prix abonné
 *   data-epy-jours   nombre de jours, pour le prix par jour
 *   data-epy-format  mwc€ (défaut, « 26,40€ »), mwc (« 26,40 »), money, mwtz (« 99€ »)
 *   data-epy-modele  texte où __X__ est remplacé par la valeur
 */
(function () {
  "use strict";
  if (window.__epyShopliftPrix) return;
  window.__epyShopliftPrix = true;

  var INPUT = ".product-header__data__form__variants__item__input";
  var etat = null;

  // ------------------------------------------------------------------ Formats monétaires
  function grouper(cents, decimales, milliers, decimal) {
    var parts = (cents / 100).toFixed(decimales).split(".");
    var entier = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, milliers);
    return parts[1] ? entier + decimal + parts[1] : entier;
  }

  // Même règle que les filtres money de Shopify, d'après shop.money_format.
  function montant(cents, sansZeros) {
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(etat.format || "");
    var cle = m ? m[1] : "amount";
    var decimales = cle.indexOf("no_decimals") !== -1 || (sansZeros && cents % 100 === 0) ? 0 : 2;
    if (cle.indexOf("comma_separator") !== -1) return grouper(cents, decimales, ".", ",");
    if (cle.indexOf("space_separator") !== -1) return grouper(cents, decimales, " ", ",");
    if (cle.indexOf("apostrophe_separator") !== -1) return grouper(cents, decimales, "'", ".");
    return grouper(cents, decimales, ",", ".");
  }

  function argent(cents, sansZeros) {
    return (etat.format || "{{amount}}").replace(/\{\{\s*\w+\s*\}\}/, montant(cents, sansZeros));
  }

  function formater(cents, style) {
    if (style === "money") return argent(cents, false);
    if (style === "mwtz") return argent(cents, true);
    if (style === "mwc") return montant(cents, false);
    return montant(cents, false) + "€";
  }

  // « 1 234,56 € », « 89.10 », « 99€ » → centimes.
  function lireCentimes(texte) {
    var t = String(texte || "").replace(/[^\d.,]/g, "");
    if (!t) return null;
    var m = /^(.*?)[.,](\d{1,2})$/.exec(t);
    var entier = (m ? m[1] : t).replace(/[.,]/g, "");
    var decimales = m ? m[2] : "";
    if (decimales.length === 1) decimales += "0";
    var cents = parseInt(entier || "0", 10) * 100 + (decimales ? parseInt(decimales, 10) : 0);
    return isNaN(cents) ? null : cents;
  }

  // ------------------------------------------------------------------ Prix testés
  function calculerEtat() {
    var variantes = {};
    var change = false;
    var format = null;
    document.querySelectorAll('[data-epy-sonde="p"]').forEach(function (sonde) {
      var v = sonde.getAttribute("data-epy-v");
      var p0 = +sonde.getAttribute("data-epy-orig");
      var c0 = +sonde.getAttribute("data-epy-orig-cap") || 0;
      format = format || sonde.getAttribute("data-epy-format");
      var p = lireCentimes(sonde.textContent);
      if (p === null) p = p0;
      var c = 0;
      if (c0 > 0) {
        // Shoplift retire la sonde du prix barré quand le prix testé n'en a pas.
        var sondeCap = sonde.parentNode && sonde.parentNode.querySelector('[data-epy-sonde="cap"][data-epy-v="' + v + '"]');
        c = sondeCap ? lireCentimes(sondeCap.textContent) : 0;
        if (c === null) c = c0;
      }
      var modifiee = p !== p0 || c !== c0;
      if (modifiee) change = true;
      // Une variante a des sondes à plusieurs endroits : la valeur écrite par Shoplift l'emporte.
      if (!variantes[v] || modifiee) variantes[v] = { p: p, c: c };
    });
    return change ? { format: format, variantes: variantes } : null;
  }

  function valeurs(v, remise) {
    var x = etat.variantes[v];
    if (!x) return null;
    var abonnement = remise !== null && remise !== "" && !isNaN(+remise);
    // Mêmes règles que le Liquid : l'abonnement retire sa remise du prix, et barre le prix
    // barré de la variante, ou à défaut son prix.
    var prix = abonnement ? Math.round((x.p * (100 - +remise)) / 100) : x.p;
    var barre = x.c > x.p ? x.c : abonnement ? x.p : 0;
    if (barre <= prix) barre = 0;
    return { prix: prix, barre: barre };
  }

  function inputPour(el) {
    var v = el.getAttribute("data-epy-v");
    if (v === "actif") {
      return document.querySelector(INPUT + '[data-epy-produit="' + el.getAttribute("data-epy-produit") + '"]:checked');
    }
    var groupe = el.closest("[data-one-time-group]");
    if (!groupe) return null;
    var carte = groupe.getAttribute("data-selected-one-time-card-id");
    return (
      groupe.querySelector(INPUT + ":checked") ||
      (carte && groupe.querySelector('[data-card-id="' + CSS.escape(carte) + '"] ' + INPUT)) ||
      groupe.querySelector(INPUT)
    );
  }

  function rendre(el) {
    var v = el.getAttribute("data-epy-v");
    var remise = el.getAttribute("data-epy-remise");
    var jours = el.getAttribute("data-epy-jours");
    if (v === "actif" || v === "groupe") {
      var input = inputPour(el);
      if (input) {
        v = input.getAttribute("data-epy-v");
        remise = input.getAttribute("data-epy-remise");
        jours = input.getAttribute("data-number-of-days") || jours;
      } else {
        v = el.getAttribute("data-epy-defaut");
        remise = el.getAttribute("data-epy-defaut-remise");
      }
    }
    var x = v ? valeurs(v, remise) : null;
    if (!x) return;

    var role = el.getAttribute("data-epy-prix");
    var cents = null;
    if (role === "prix") cents = x.prix;
    else if (role === "barre") cents = x.barre || null;
    else if (role === "economie") cents = x.barre ? x.barre - x.prix : null;
    else if (role === "pourcent") cents = x.barre ? -Math.round(((x.barre - x.prix) * 100) / x.barre) : null;
    else if (role === "jour") cents = +jours > 0 ? Math.round(x.prix / +jours) : null;

    el.classList.toggle("hide", cents === null);
    if (cents === null) {
      if (role === "barre") el.textContent = "";
      return;
    }
    var texte = role === "pourcent" ? String(cents) : formater(cents, el.getAttribute("data-epy-format"));
    var modele = el.getAttribute("data-epy-modele");
    var html = modele ? modele.split("__X__").join(texte) : texte;
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  function reecrireBoutonsRadio() {
    document.querySelectorAll(INPUT + "[data-epy-v]").forEach(function (input) {
      var x = valeurs(input.getAttribute("data-epy-v"), input.getAttribute("data-epy-remise"));
      if (!x) return;
      input.setAttribute("data-base-price", montant(x.barre || x.prix, false));
      input.setAttribute("data-discounted-price", x.barre ? montant(x.prix, false) : "");
    });
  }

  function appliquer() {
    etat = calculerEtat();
    if (!etat) return;
    reecrireBoutonsRadio();
    document.querySelectorAll("[data-epy-prix]").forEach(rendre);
  }

  var attente = null;
  function planifier() {
    if (attente) return;
    attente = setTimeout(function () {
      attente = null;
      appliquer();
    }, 0);
  }

  function demarrer() {
    appliquer();
    // Shoplift écrit dans les sondes à son rythme (au chargement, puis 100 et 500 ms après).
    document.querySelectorAll(".epy-sl-sondes").forEach(function (conteneur) {
      new MutationObserver(planifier).observe(conteneur, { childList: true, characterData: true, subtree: true });
    });
    setTimeout(appliquer, 700);
    // Le JS du thème réécrit les prix au changement de variante, et arrête la propagation sur la
    // carte : on écoute en phase de capture, puis on repasse après lui.
    document.addEventListener("change", planifier, true);
  }

  // ------------------------------------------------------------------ Ajout au panier
  // Variantes des formulaires dont le champ _slpt a reçu une valeur de Shoplift.
  function variantesTestees() {
    var ids = {};
    document.querySelectorAll('input[name="properties[_slpt]"]').forEach(function (champ) {
      var form = champ.form || champ.closest("form");
      if (!champ.value || !form) return;
      form.querySelectorAll('input[name="id"]').forEach(function (input) {
        if (input.value) ids[String(input.value)] = champ.value;
      });
    });
    return ids;
  }

  // À la première page vue, Shoplift affiche les prix de la version tirée au sort mais remplit
  // _slpt avec « control » tant que ce tirage n'est pas enregistré (constaté le 27/10/2026 : prix
  // B affichés, _slpt « control », donc 33 € facturés pour 35 € affichés). On aligne la version
  // de _slpt sur celle dont les prix sont affichés.
  function versionAffichee(item, valeur) {
    var parts = String(valeur || "").split(":");
    var instance = window.shopliftInstance;
    if (parts.length !== 3 || !instance || !instance.testConfigs) return valeur;
    var affiche = prixAffiche(item.id);
    var test = instance.testConfigs.filter(function (t) { return t.id === parts[0]; })[0];
    if (affiche === null || !test) return valeur;
    var versions = (test.hypotheses || []).filter(function (h) {
      return h.priceData && h.priceData.variants.some(function (x) {
        return String(x[0]) === String(item.id) && x[1] === affiche;
      });
    });
    if (versions.length !== 1) return valeur;
    return parts[0] + ":" + (versions[0].isControl ? "control" : "variant") + ":" + parts[2];
  }

  function ajouterSlpt(item, ids) {
    var valeur = ids[String(item.id)] && versionAffichee(item, ids[String(item.id)]);
    // Un abonnement passe par le plan de vente de sa version (voir planPourVersion).
    if (!valeur || item.selling_plan) return false;
    item.properties = item.properties || {};
    // Une valeur déjà posée (par Shoplift lui-même) est corrigée de la même façon.
    var finale = item.properties._slpt ? versionAffichee(item, item.properties._slpt) : valeur;
    if (item.properties._slpt === finale) return false;
    item.properties._slpt = finale;
    return true;
  }

  // Prix « achat unique » affiché pour une variante, tel que Shoplift l'a écrit dans sa sonde.
  function prixAffiche(v) {
    var sonde = document.querySelector('[data-epy-sonde="p"][data-epy-v="' + v + '"]');
    return sonde ? lireCentimes(sonde.textContent) : null;
  }

  // Abonnement : pendant un test, Shoplift aligne le prix Shopify sur la version la plus chère
  // et crée dans Recharge un plan de remise propre à l'autre version (ex. -24,57 % au lieu de
  // -20 %). Il ne substitue ce plan que dans le widget Recharge standard ; le widget du thème
  // envoie toujours le plan d'origine. On choisit donc ici le plan de la version affichée au
  // visiteur, d'après le prix lu dans les sondes (même règle que Shoplift : un test « increase »
  // donne le plan créé à la version d'origine, un test « decrease » à la version testée).
  function planPourVersion(item) {
    var plan = String(item.selling_plan || "");
    var instance = window.shopliftInstance;
    if (!plan || !instance || !instance.testConfigs) return null;
    var affiche = prixAffiche(item.id);
    if (affiche === null) return null;
    var resultat = null;
    instance.testConfigs.forEach(function (test) {
      var versions = (test.hypotheses || []).filter(function (h) {
        return h.subscriptionData && h.priceData && h.priceData.variants.some(function (x) {
          return String(x[0]) === String(item.id) && x[1] === affiche;
        });
      });
      // Les deux versions au même prix : impossible de savoir laquelle est affichée.
      if (versions.length !== 1) return;
      var version = versions[0];
      version.subscriptionData.plans.forEach(function (p) {
        if (p.variantId && String(p.variantId) !== String(item.id)) return;
        var cree = p.direction === "decrease" ? !version.isControl : version.isControl;
        var voulu = String(cree ? p.createdShopifyPlanId : p.existingShopifyPlanId);
        if (plan === String(p.existingShopifyPlanId) || plan === String(p.createdShopifyPlanId)) resultat = voulu;
      });
    });
    return resultat && resultat !== plan ? resultat : null;
  }

  function echangerPlan(item) {
    var plan = planPourVersion(item);
    if (!plan) return false;
    item.selling_plan = typeof item.selling_plan === "number" ? Number(plan) : plan;
    return true;
  }

  var fetchOrigine = window.fetch;
  window.fetch = function (ressource, options) {
    try {
      var url = typeof ressource === "string" ? ressource : (ressource && (ressource.url || ressource.href)) || "";
      if (url.indexOf("/cart/add") !== -1 && options && options.body) {
        var ids = variantesTestees();
        var teste = false;
        if (typeof options.body === "string") {
          var corps = JSON.parse(options.body);
          var items = corps.items || (corps.id ? [corps] : []);
          var modifie = false;
          items.forEach(function (item) {
            if (ids[String(item.id)]) teste = true;
            if (ajouterSlpt(item, ids)) modifie = true;
            if (echangerPlan(item)) modifie = true;
          });
          if (modifie) options = Object.assign({}, options, { body: JSON.stringify(corps) });
        } else if (options.body instanceof FormData) {
          var idForm = options.body.get("id");
          var valeur = ids[String(idForm)] && versionAffichee({ id: idForm }, ids[String(idForm)]);
          if (valeur) teste = true;
          if (valeur && !options.body.get("selling_plan")) options.body.set("properties[_slpt]", valeur);
          var planForm = planPourVersion({ id: idForm, selling_plan: options.body.get("selling_plan") });
          if (planForm) options.body.set("selling_plan", planForm);
        }
        // L'intercepteur de Shoplift, quand il passe après ce script, réécrit _slpt sans condition
        // avec la version de son code d'abonnement (« control » à la première page, constaté le
        // 27/10/2026) et ne touche qu'aux requêtes dont le corps est dans les options. Pour un
        // produit en test, on envoie donc une Request : les autres scripts la lisent normalement,
        // et ce script a déjà fait les deux corrections de Shoplift (_slpt et plan d'abonnement).
        if (teste) return fetchOrigine.call(window, new Request(url, options));
      }
    } catch (erreur) {
      // Requête laissée telle quelle : l'ajout au panier ne doit jamais échouer à cause du test.
    }
    return fetchOrigine.call(window, ressource, options);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", demarrer);
  } else {
    demarrer();
  }
})();
